import { FormattedMessage, useIntl } from "react-intl";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { Button, ButtonGroup, ButtonToolbar } from "react-bootstrap";
import BootstrapTable from "react-bootstrap/Table";

const Table = (props) => {
  const { columns, data } = props;

  const intl = useIntl();
  const tableProps = { ...props };

  delete tableProps.columns;
  delete tableProps.data;

  return (
    <BootstrapTable {...tableProps}>
      <thead>
        <tr>
          {columns.map((col, i) => (
            <th key={i} className={col.className}>
              {col.labelKey && <FormattedMessage id={col.labelKey} />}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data &&
          data.map((row, rowIndex) => (
            <tr key={"row" + rowIndex}>
              {columns.map((col, colIndex) => (
                <td key={"col" + colIndex}>
                  {col.actions && (
                    <ButtonToolbar>
                      <ButtonGroup>
                        {col.actions.map((action, i) => {
                          let hidden = false;
                          if (typeof action.hidden === "function") {
                            hidden = action.hidden(row);
                          }

                          if (hidden) {
                            return null;
                          }

                          let disabled = false;
                          if (typeof action.disabled === "function") {
                            disabled = action.disabled(row);
                          }

                          let className = action.className;
                          if (typeof action.className === "function") {
                            className = action.className(row);
                          }

                          return (
                            <Button
                              key={i}
                              size="sm"
                              className={className}
                              variant={action.variant || "link"}
                              disabled={disabled}
                              onClick={() => action.onClick(row)}
                              title={intl.formatMessage({ id: action.labelKey })}
                            >
                              <FontAwesomeIcon icon={action.icon} />
                            </Button>
                          );
                        })}
                      </ButtonGroup>
                    </ButtonToolbar>
                  )}
                  {col.customBodyRenderer ? col.customBodyRenderer(row) : row[col.name]}
                </td>
              ))}
            </tr>
          ))}
      </tbody>
    </BootstrapTable>
  );
};

Table.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default Table;
